import dashboard from './dashboard';
import widget from './widget';
import application from './application';
import forms from './forms';
import elements from './elements';
import pages from './pages';
import utilities from './utilities';
import support from './support';
import other from './other';
import blog from './blog';
import reddit from './reddit';
import engagement from './engagement';
import installs from './installs';
import readinessConfig from './readiness-config';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    // items: [dashboard, widget, application, forms, elements, pages, utilities, support, other]
    items: [dashboard, application, blog, installs, engagement, readinessConfig, reddit]
};

export default menuItems;
